import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import MutationMiddleware from '../../../../middleware/modules/mutation/mutation';
import i18n from '../../../../i18n';
import { Helmet } from 'react-helmet';
import MutationAll from "../../../../components/modules/mutation/mutation/index-all";
// middlewares
const mapStateToProps = ({ mutasi, }) => ({
  isProcessingItem: mutasi.isProcessingItem,
  isError: mutasi.isError,
  errorMessage: mutasi.errorMessage,
  helperList:mutasi.helperMutation,
  onChooseItem: mutasi.onChooseItem,
  // data: mutasi.data,
  dataItem: mutasi.dataItem,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getDataItem: (data) => MutationMiddleware.getDataItem(data),
    },
    dispatch
  );
};
class MutationAllContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessingItem: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalistItem: PropTypes.object,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessingItem: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      show: 0,
    };
    this.getDataItem = this.getDataItem.bind(this);

  }

  getDataItem() {
    this.props.getDataItem();
  }
  
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Mutation All")}
          </title>
        </Helmet>
      <MutationAll
        {...this.props}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MutationAllContainer);
